/**
 * Gestione dei menu dropdown a tendina.
 */

export default $ => {
  /**
   * Currently open dropdown
   * @type {jQUery}
   */
  let currentOpen = null;

  /**
   * Calculate position for the dropdown
   */
  const _dropdownPosition = () => {
    if (currentOpen) {
      const container = $(currentOpen.data('dropdown'));

      const offset = currentOpen.offset();

      const h = currentOpen.height();
      const w = currentOpen.outerWidth(true);

      const winWidth = $(window).width();
      const winHeight = $(window).height();
      const scrollLeft = $(document).scrollLeft();
      const scrollTop = $(document).scrollTop();
      const position = {
        left: offset.left + w/2 - scrollLeft,
        top: offset.top + h - scrollTop,
      };

      if (position.left+w > winWidth) {
        position.left = position.left - (position.left + w - winWidth);
      }

      var dropdownHeight = container.outerHeight(true);
      if (position.top+dropdownHeight+20 > winHeight) {
        // the dropdown becomes a dropup
        position.top = position.top - h - dropdownHeight - 20;
      }

      container.css(position);
    }
  };

  /**
   * Show a dropdown
   * @param  {jQuery} dropdownToggle
   */
  const _drowpdownShow = (dropdownToggle) => {
    currentOpen = dropdownToggle;
    const container = $(currentOpen.data('dropdown'));
    container.addClass('eDropdown uIsOpen');
    currentOpen.addClass('uIsToggled');

    if ($('> .eDropdown__Arrow', container).length == 0) {
      container.prepend($('<span class="eDropdown__Arrow"/>'));
    }

    _dropdownPosition(currentOpen);
  };

  /**
   * Hide a dropdown
   */
  const _drowpdownHide = () => {
    if (currentOpen) {
      $(currentOpen.data('dropdown')).removeClass('uIsOpen');
      currentOpen.removeClass('uIsToggled');
      currentOpen = null;
    }
  };

  // ===========================================================================
  // Event handlers
  // ===========================================================================
  const hide = event => {
    const container = $('.eDropdown.uIsOpen');

    // Se il target del link è l'elemento stesso oppure un suo discendente
    if (!container.is(event.target) && container.has(event.target).length === 0) {
      _drowpdownHide();
      $(document).unbind('mouseup', hide);
      $(document).unbind('scroll', reposition);
    }
  };

  const show = function () {
    _drowpdownHide();

    if ($($(this).data('dropdown')).length > 0) {
        _drowpdownShow($(this));

        $(document).mouseup(hide);
        $(document).scroll(reposition);
        $(this).parents().scroll(reposition);
    }
  };

  const reposition = function() {
    _dropdownPosition();
  };

  $('body').on('click', '[data-dropdown]', show);
};



// WEBPACK FOOTER //
// ./assets/js/component/dropdown.js